export default "__VITE_ASSET__8fd634dc__"